import React from "react";
import EmojiListItem from "./EmojiListItem";

import "./styles.scss";

const EmojiList = ({emojiList, filteredEmoji, onSelectEmoji, activeReactions, onRemoveEmoji, disabled}) => {
    return (
        <>
            {!!emojiList
                ? <ul
                    className="emoji-picker-smileys container-scroll"
                >
                    {Object.entries(emojiList).map(([categoryName, categoryEmoji]) => (
                        (filteredEmoji?.[categoryName].length || !filteredEmoji) &&
                        <EmojiListItem
                            key={categoryName}
                            category={categoryName}
                            emojiList={categoryEmoji}
                            filteredEmoji={filteredEmoji?.[categoryName] || []}
                            onSelectEmoji={onSelectEmoji}
                            activeReactions={activeReactions}
                            onRemoveEmoji={onRemoveEmoji}
                            disabled={disabled}
                        />
                    ))}
                </ul>
                : <p></p>
            }
        </>
    );
};

export default EmojiList;
